__turbopack_context__.v({
  "banner_text": "Topbanner-module-scss-module__Ax-mHG__banner_text",
  "top_banner": "Topbanner-module-scss-module__Ax-mHG__top_banner",
});
